import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import styled from 'styled-components';
import Header from './components/Header';
import Hero from './components/Hero';
import AboutCompany from './components/AboutCompany';
import ProductsOverview from './components/ProductsOverview';
import Contact from './components/Contact';
import Footer from './components/Footer';
import PasswordProtection from './components/PasswordProtection';
import PasswordViewer from './components/PasswordViewer';
import Roadmap from './components/Roadmap';
import ProductPage from './components/ProductPage';
import ResourcesPage from './components/ResourcesPage';
import { ink, paper } from './theme';

const AppContainer = styled.div`
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
  background: ${paper};
  min-height: 100vh;
  /* clip вместо hidden — иначе position: sticky у дочерних секций часто не работает */
  overflow-x: clip;
  color: ${ink};
`;

const GlobalStyles = styled.div`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }

  .section {
    padding: 80px 0;
  }

  .section-title {
    font-size: 2.5rem;
    font-weight: 700;
    text-align: center;
    margin-bottom: 3rem;
    color: ${ink};
    letter-spacing: -0.02em;
  }

  .section-subtitle {
    font-size: 1.2rem;
    text-align: center;
    margin-bottom: 4rem;
    color: #4a5568;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
  }

  .btn {
    display: inline-block;
    padding: 12px 30px;
    background: ${ink};
    color: white;
    text-decoration: none;
    border-radius: 2px;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    font-size: 0.85rem;
    transition: all 0.2s ease;
    border: 1px solid ${ink};
    cursor: pointer;
    box-shadow: 0 4px 16px rgba(3, 26, 56, 0.18);

    &:hover {
      transform: translateY(-2px);
      background: #052a52;
      box-shadow: 0 8px 22px rgba(3, 26, 56, 0.22);
    }
  }

  .btn-secondary {
    background: ${paper};
    color: ${ink};
    border: 2px solid ${ink};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

    &:hover {
      background: rgba(3, 26, 56, 0.06);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    }
  }

  .card {
    background: ${paper};
    border-radius: 2px;
    padding: 30px;
    border: 1px solid rgba(3, 26, 56, 0.22);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.06);
    transition: all 0.2s ease;

    &:hover {
      transform: translateY(-3px);
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
    }
  }

  .grid {
    display: grid;
    gap: 30px;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  }

  @media (max-width: 768px) {
    .section {
      padding: 60px 0;
    }

    .section-title {
      font-size: 2rem;
    }

    .container {
      padding: 0 15px;
    }
  }

  @media (max-width: 480px) {
    .section {
      padding: 50px 0;
    }

    .section-title {
      font-size: 1.8rem;
    }

    .section-subtitle {
      font-size: 1.1rem;
    }

    .container {
      padding: 0 12px;
    }

    .btn {
      padding: 10px 25px;
      font-size: 0.95rem;
    }

    .card {
      padding: 25px 20px;
    }
  }

  @media (max-width: 360px) {
    .section {
      padding: 40px 0;
    }

    .section-title {
      font-size: 1.6rem;
    }

    .section-subtitle {
      font-size: 1rem;
    }

    .container {
      padding: 0 10px;
    }

    .btn {
      padding: 10px 20px;
      font-size: 0.9rem;
    }

    .card {
      padding: 20px 15px;
    }
  }
`;

// Компонент основного контента сайта
const MainContent = () => (
  <>
    <Header />
    <Hero />
    <AboutCompany />
    <ProductsOverview />
    <Contact />
    <Footer />
  </>
);

function App() {
  return (
    <Router>
      <AppContainer>
        <GlobalStyles />
        <Routes>
          {/* Маршрут для просмотра пароля - без защиты */}
          <Route path="/password/secret" element={<PasswordViewer />} />
          
          {/* Маршрут для дорожной карты - без защиты */}
          <Route path="/roadmap" element={<Roadmap />} />
          
          {/* Маршрут для страницы продукта e-node оазис (cloud) */}
          <Route path="/product/e-node-cloud" element={<ProductPage />} />

          {/* Закрытый раздел ресурсов */}
          <Route path="/resources" element={
            <PasswordProtection>
              <ResourcesPage />
            </PasswordProtection>
          } />
          
          {/* Основной маршрут без защиты */}
          <Route path="/*" element={<MainContent />} />
        </Routes>
      </AppContainer>
    </Router>
  );
}

export default App;
